/** One tool advertised by the MCP server (the DB-backed catalog the eval API
 * serves at GET /v1/mcp/tools). `feature_flag` is null when the tool is always
 * on; `is_write` marks tools that mutate data. */
export type McpTool = {
  name: string
  description: string | null
  input_schema: Record<string, unknown>
  feature_flag: string | null
  is_write: boolean
}

export type McpToolListResponse = {
  tools: McpTool[]
  total: number
}

export type ToolOption = {
  label: string
  value: string
}

/**
 * Build the dropdown options for a tool search: every catalog tool name that
 * isn't already selected. Sorted by name (the API already returns them sorted,
 * but selecting/removing must not depend on that). Used by the Forbidden writes
 * and Must call pickers.
 */
export const availableToolOptions = (
  tools: McpTool[],
  selected: string[],
): ToolOption[] => {
  const taken = new Set(selected)
  return tools
    .filter((tool) => !taken.has(tool.name))
    .map((tool) => ({ label: tool.name, value: tool.name }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

/** Append a tool name to the selection, ignoring duplicates. */
export const addTool = (selected: string[], name: string): string[] =>
  selected.includes(name) ? selected : [...selected, name]

/** Remove a tool name from the selection. */
export const removeTool = (selected: string[], name: string): string[] =>
  selected.filter((existing) => existing !== name)
